export function getPhaseParameters(metadata) {
    const result = { ph0: undefined, ph1: undefined };
    if ('.PHASE0' in metadata) {
        result.ph0 = parseFloat(metadata['.PHASE0']);
        result.ph1 = parseFloat(metadata['.PHASE1']);
    }
    return result;
}
export function hasPhaseParameters(phaseParameters) {
    const { ph0, ph1 } = phaseParameters;
    return ph0 !== undefined && ph1 !== undefined;
}
//# sourceMappingURL=getPhaseParameters.js.map